import React from 'react';

import { LoginButton } from './LoginButton.styles';

const CustomButton = ({ children, ...otherProps }) => (
  <LoginButton>
    <button className="custom-button" {...otherProps}>
      {children}
    </button>
  </LoginButton>
);

export default CustomButton;
